


import { JsonEditorSchemaType } from "../models/JsonEditorCdnSchemaType";
import IJsonEditorSchemaGenerator from "./IJsonEditorSchemaGenerator";
import DataCleaningSchemaGenerator from "./DataCleaningSchemaGenerator";
import AnalysisConfigSchemaGenerator from "./AnalysisConfigSchemaGenerator";
import CustomCalculationSchemaGenerator from "./CustomCalculationsSchemaGenerator";
import CustomPlotsSchemaGenerator from "./CustomPlotsSchemaGenerator";
import CustomTablesSchemaGenerator from "./CustomTablesSchemaGenerator";
import CustomReportsSchemaGenerator from "./CustomReportsSchemaGenerator";


export class JsonEditorSchemaFactory {

    private static registry: Map<JsonEditorSchemaType | string, IJsonEditorSchemaGenerator<any>> = new Map();

    // register built-in generators
    public static registerDefaults() {
        if (!this.registry.has(JsonEditorSchemaType.RuleSchema)) {
            this.registry.set(JsonEditorSchemaType.RuleSchema, new DataCleaningSchemaGenerator());
        }
        if (!this.registry.has(JsonEditorSchemaType.AnalysisConfigSchema)) {
            this.registry.set(JsonEditorSchemaType.AnalysisConfigSchema, new AnalysisConfigSchemaGenerator());
        }
        if (!this.registry.has(JsonEditorSchemaType.CalculationSchema)) {
            this.registry.set(JsonEditorSchemaType.CalculationSchema, new CustomCalculationSchemaGenerator());
        }
        if (!this.registry.has(JsonEditorSchemaType.PlotSchema)) {
            this.registry.set(JsonEditorSchemaType.PlotSchema, new CustomPlotsSchemaGenerator());
        }
        if (!this.registry.has(JsonEditorSchemaType.TableSchema)) {
            this.registry.set(JsonEditorSchemaType.TableSchema, new CustomTablesSchemaGenerator());
        }
        if (!this.registry.has(JsonEditorSchemaType.CustomReportSchema)) {
            this.registry.set(JsonEditorSchemaType.CustomReportSchema, new CustomReportsSchemaGenerator());
        }
    }

    public static register(type: JsonEditorSchemaType, generator: IJsonEditorSchemaGenerator<any>) {
        this.registry.set(type, generator);
    }

    public static get<TQueueExecutionProp>(type: JsonEditorSchemaType | string): IJsonEditorSchemaGenerator<TQueueExecutionProp> {
        this.registerDefaults();
        const key = type as string;
        const generator = this.registry.get(key);
        if (generator == null) throw Error(`Unable to resovle IJsonEditorSchemaGenerator for type: ${type}`)
        return generator;
    }

}

export default JsonEditorSchemaFactory;